import { Stack, Typography } from '@mui/material';

import { styled } from '@/theme/styled';

const Container = styled(Stack)(({ theme }) => ({
  padding: theme.spacing(2),
}));

const EntityName = styled(Typography)(({ theme }) => ({
  maxWidth: 145,
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  whiteSpace: 'nowrap',
}));

EntityName.defaultProps = {
  variant: 'h5',
};

export { Container, EntityName };
